<template>
  <div class="row">
    <div class="col-12">
      <h2 class="titre">
        Recherche catégorie
      </h2>
    </div>
  </div>
  <CriteresRechercheCategorie @rechercher="rechercher" @fermer="fermer"/>
  <ResultatRechercheCategorie :categories="categories" :isRechercheDataLoading="isRechercheDataLoading"/>
</template>

<script>

import ResultatRechercheCategorie from "@/components/pilotage/ClassementDeDossier/ResultatRechercheCategorie.vue";
import CriteresRechercheCategorie from "@/components/pilotage/ClassementDeDossier/CriteresRechercheCategorie.vue";
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "RechercherCategorie",
  components: {
      CriteresRechercheCategorie,
      ResultatRechercheCategorie
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  data() {
    return {
      isRechercheDataLoading: false,
      categories: [],
    }
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Recherche Catégorie");
  },
  methods: {
    rechercher(libelleRecherche) {
      this.categories = [];
      this.isRechercheDataLoading = true;
      this.$store.dispatch('pilotage/rechercherTableValeurAvecAscAction', libelleRecherche)
        .then((res) => {
          res.data.libelles.forEach((currentEntite) => {
            currentEntite.tableValeur.libelles.forEach((currentGenre) => {
              currentGenre.tableValeur.libelles.forEach((currentNature) => {
                currentNature.tableValeur.libelles.forEach((currentType) => {
                  currentType.tableValeur.libelles.forEach((currentCategorie) => {
                    let currentCategorieComplete = currentCategorie;
                    currentCategorieComplete.entiteCle = currentEntite.tableValeur.cle
                    currentCategorieComplete.entite = currentEntite.tableValeur.description;
                    currentCategorieComplete.genreCle = currentGenre.tableValeur.cle
                    currentCategorieComplete.genre = currentGenre.tableValeur.description;
                    currentCategorieComplete.natureCle = currentNature.tableValeur.cle
                    currentCategorieComplete.nature = currentNature.tableValeur.description;
                    currentCategorieComplete.typeCle = currentType.tableValeur.cle;
                    currentCategorieComplete.type = currentType.tableValeur.description;
                    this.categories.push(currentCategorieComplete);
                  })
                })
              })
            })
          })
          this.isRechercheDataLoading = false;
        })
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>
